(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hoa-popup"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-hoa-pop]');
    if (!root) return;
    var DONE = 'hoaPopDone', SNOOZE = 'hoaPopSnooze';
    var ask = root.querySelector('[data-hoa-pop-ask]');
    var done = root.querySelector('[data-hoa-pop-done]');
    var form = root.querySelector('[data-hoa-pop-form]');
    var email = root.querySelector('#hoa-pop-email');
    var cta = form && form.querySelector('.hoa-pop__cta');
    var err = root.querySelector('[data-hoa-pop-error]');
    var delay = Math.max(2, parseInt(root.getAttribute('data-delay'), 10) || 7) * 1000;
    var snoozeDays = parseInt(root.getAttribute('data-snooze'), 10) || 7;
    var opened = false, timer = null;

    function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

    function blockedPage() {
      var p = location.pathname;
      return /^\/(cart|checkouts?|account|policies|challenge)/.test(p);
    }
    function eligible() {
      if (get(DONE) === '1') return false;
      var until = parseInt(get(SNOOZE) || '0', 10);
      if (until && until > Date.now()) return false;
      return !blockedPage();
    }

    function open(state) {
      if (opened) return;
      opened = true;
      clearTimeout(timer);
      if (state === 'done') { ask.hidden = true; done.hidden = false; }
      root.hidden = false;
      document.documentElement.classList.add('hoa-pop-open');
      document.documentElement.style.overflow = 'hidden';
      if (state !== 'done' && email) setTimeout(function () { try { email.focus({ preventScroll: true }); } catch (e) {} }, 380);
      document.removeEventListener('mouseleave', onLeave);
    }
    function close() {
      root.hidden = true;
      document.documentElement.classList.remove('hoa-pop-open');
      document.documentElement.style.overflow = '';
      if (get(DONE) !== '1') set(SNOOZE, String(Date.now() + snoozeDays * 864e5));
    }
    function onLeave(e) {
      if (e.clientY <= 0 && eligible()) open();
    }

    root.querySelectorAll('[data-hoa-pop-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (el.tagName !== 'A') e.preventDefault();
        close();
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) close();
    });

    if (form) {
      /* Deliberately a NORMAL form submit, not fetch. Shopify answers a fetched
         POST to /contact with 403 and a captcha challenge body, so an XHR flow
         silently drops the signup. A native submit goes through that challenge
         properly, then Shopify redirects to return_to (/?hoa_pop=ok) and the
         block at the bottom reopens this popup in its success state. */
      form.addEventListener('submit', function () {
        if (!form.checkValidity()) return;
        err.hidden = true;
        cta.classList.add('is-busy');
        cta.disabled = true;
        /* re-enable if the browser restores the page from bfcache */
        setTimeout(function () { cta.classList.remove('is-busy'); cta.disabled = false; }, 12000);
      });
    }

    var copy = root.querySelector('[data-hoa-pop-copy]');
    if (copy) copy.addEventListener('click', function () {
      var code = root.querySelector('[data-hoa-pop-code]').textContent.trim();
      var fin = function () { copy.textContent = 'Copied'; setTimeout(function () { copy.textContent = 'Copy'; }, 1600); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(fin, fin);
      else fin();
    });

    /* returned from a non-JS submit: show the code, retire the popup */
    if (root.hasAttribute('data-done-now') || /[?&]hoa_pop=ok/.test(location.search)) {
      set(DONE, '1');
      open('done');
      return;
    }
    if (!eligible()) return;
    timer = setTimeout(function () { if (eligible()) open(); }, delay);
    document.addEventListener('mouseleave', onLeave);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hoa-try-nudge"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-hoa-nudge]');
    if (!root) return;

    var KEY = 'hoaNudge';
    var SESSION = 'hoaNudgeSeen';
    var LAST = 'hoaTryLast';
    var design = !!(window.Shopify && window.Shopify.designMode);
    var page = root.getAttribute('data-page');
    var delay = parseInt(root.getAttribute('data-delay'), 10) || 14;
    var scrollAt = (parseInt(root.getAttribute('data-scroll'), 10) || 40) / 100;
    var snoozeDays = parseInt(root.getAttribute('data-snooze'), 10) || 5;
    var trySection = document.getElementById('try');
    var shown = false, dead = false, timer = null;

    function readJSON(store, key) {
      try { return JSON.parse(store.getItem(key) || '{}'); } catch (e) { return {}; }
    }
    function write(obj) {
      try { localStorage.setItem(KEY, JSON.stringify(obj)); } catch (e) {}
    }

    /* someone who has already rendered a room does not need to be told about it */
    function hasUsedTool() {
      var store = readJSON(localStorage, 'hoaTryStore');
      return Object.keys(store).length > 0;
    }
    function snoozed() {
      var s = readJSON(localStorage, KEY);
      return s.until && Date.now() < s.until;
    }
    function seenThisSession() {
      try { return sessionStorage.getItem(SESSION) === '1'; } catch (e) { return false; }
    }

    /* remember the last piece opened, so a nudge on a collection or the home page
       offers the piece the visitor actually cared about */
    if (page === 'product') {
      var img = root.querySelector('.hoa-nudge__img');
      try {
        localStorage.setItem(LAST, JSON.stringify({
          handle: root.getAttribute('data-handle'),
          url: (root.querySelector('[data-nudge-go]') || {}).href || '',
          img: img ? (img.currentSrc || img.src) : '',
          name: (document.querySelector('.product-details h1') || {}).textContent || ''
        }));
      } catch (e) {}
    } else {
      var last = readJSON(localStorage, LAST);
      if (last.url && last.handle && last.handle !== root.getAttribute('data-handle')) {
        var short = (last.name || '').split(' | ')[0].split(' ')[0].trim();
        root.querySelectorAll('[data-nudge-go]').forEach(function (a) { a.href = last.url; });
        root.setAttribute('data-handle', last.handle);
        if (last.img) {
          var im = root.querySelector('.hoa-nudge__img');
          if (im) im.src = last.img;
        }
        if (short) {
          var t = root.querySelector('[data-nudge-title]');
          var tpl = root.getAttribute('data-title-tpl') || '';
          if (t && tpl.indexOf('[piece]') === -1) t.textContent = 'See the ' + short + ' in your own room.';
        }
      }
    }

    function busy() {
      /* never speak over a drawer, a dialog or the email popup */
      return !!document.querySelector('dialog[open], cart-drawer-component[open], .cart-drawer[open], [data-hoa-pop]:not([hidden])');
    }

    function lift() {
      /* sit above the mobile buy bar when it is out */
      var h = 0;
      if (window.innerWidth < 750) {
        /* the visible bar is .sticky-add-to-cart__bar; its <sticky-add-to-cart>
           wrapper stays in the flow at zero height, so measure the bar itself */
        var bars = document.querySelectorAll('.sticky-add-to-cart__bar, sticky-add-to-cart, .sticky-add-to-cart');
        for (var i = 0; i < bars.length; i++) {
          var r = bars[i].getBoundingClientRect();
          if (r.height > 20 && r.top < window.innerHeight - 4 && r.bottom > window.innerHeight - 140) {
            h = Math.max(h, Math.round(r.height + 8));
          }
        }
      }
      root.style.setProperty('--hoa-nudge-lift', h + 'px');
    }

    function show() {
      if (shown || dead) return;
      if (!design && busy()) { timer = setTimeout(show, 4000); return; }
      shown = true;
      root.hidden = false;
      lift();
      requestAnimationFrame(function () { root.classList.add('is-in'); });
      try { sessionStorage.setItem(SESSION, '1'); } catch (e) {}
      window.addEventListener('resize', lift);
      document.addEventListener('scroll', lift, { capture: true, passive: true });
    }

    function hide(snooze) {
      dead = true;
      clearTimeout(timer);
      root.classList.remove('is-in');
      setTimeout(function () { root.hidden = true; }, 420);
      if (snooze) write({ until: Date.now() + snoozeDays * 864e5 });
    }

    root.querySelectorAll('[data-nudge-close]').forEach(function (b) {
      b.addEventListener('click', function () { hide(true); });
    });

    /* on a product page the tool is right there: scroll to it, wake it up */
    root.querySelectorAll('[data-nudge-go]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        write({ until: Date.now() + snoozeDays * 864e5 });
        if (!trySection) return;
        e.preventDefault();
        hide(false);
        trySection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var drop = trySection.querySelector('[data-try-drop]');
        if (drop) {
          drop.classList.remove('hoa-try--flash');
          void drop.offsetWidth;
          drop.classList.add('hoa-try--flash');
        }
        setTimeout(function () {
          var label = trySection.querySelector('label[for^="hoa-try-file"]');
          if (label) label.focus({ preventScroll: true });
        }, 700);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && shown && !dead) hide(true);
    });

    /* the moment someone reaches the tool on their own, this card has no job left */
    if (trySection && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries, obs) {
        if (entries.some(function (en) { return en.isIntersecting; })) {
          obs.disconnect();
          if (!shown) dead = true; else hide(false);
        }
      }, { threshold: 0.15 }).observe(trySection);
    }

    /* on the home page the teaser makes this point already: wait until it is gone.
       Measured, not observed: an IntersectionObserver never fires when a fast
       scroll jumps clean past the element without ever intersecting it. */
    var gate = page === 'index' ? document.querySelector('.hoa-tt') : null;
    function gatePassed() {
      if (!gate) return true;
      return gate.getBoundingClientRect().bottom < 0;
    }

    if (design) { show(); return; }
    if (hasUsedTool() || snoozed() || seenThisSession()) return;

    timer = setTimeout(function ready() {
      /* on the home page the teaser owns this message until it is scrolled past;
         keep waiting rather than talking over it */
      if (gatePassed()) show(); else timer = setTimeout(ready, 2000);
    }, delay * 1000);

    /* html and body carry overflow:hidden on some templates and .page-wrapper does
       the scrolling, so window never sees a scroll event: listen on the capture
       phase and read the progress off whichever element actually moved */
    function progressOf(el) {
      if (!el || el === document || el === window) el = document.scrollingElement || document.documentElement;
      var span = el.scrollHeight - el.clientHeight;
      return span > 40 ? el.scrollTop / span : 0;
    }
    document.addEventListener('scroll', function onScroll(e) {
      if (dead || shown) return;
      if (progressOf(e.target) >= scrollAt && gatePassed()) show();
    }, { capture: true, passive: true });

    /* desktop only: someone heading for the tab bar gets one last offer */
    if (window.matchMedia('(min-width: 990px)').matches) {
      document.addEventListener('mouseout', function onOut(e) {
        if (!e.relatedTarget && e.clientY <= 4 && gatePassed()) {
          document.removeEventListener('mouseout', onOut);
          show();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
